<template lang="pug">
  .wrapper
    OnPagePurchaseBox(v-if="onPagePurchaseBoxExperiment" :version="onPagePurchaseBoxExperimentVersion")

    AddProduct(cta-source="ctaSource" v-slot="{ addProductToOrderOrBag, addToBag, canAddToRefillCart }")
      .pdp-ctas-v2
        .cta-block(ref="ctaContainer")
          MrBtn.shipment.pdp-btn.mr-50m(v-if="canAddToRefillCart"
            block
            xsmall
            noBorderRadius
            brandColor1
            ref="ctaButton"
            @click="trackAddToBagEvent(addProductToOrderOrBag, `${trackingPrefix} - Page Add to Shipment CTA`)"
            :disabled="Boolean(addingProduct)"
          ) Add to next shipment
          MrBtn.pdp-btn(
            block
            xsmall
            noBorderRadius
            brandColor1
            :class="{ 'pdp-btn-secondary': canAddToRefillCart }"
            ref="ctaButton"
            @click="trackAddToBagEvent(addToBag, `${trackingPrefix} - Page CTA`)"
            :disabled="Boolean(addingProduct)"
          ) Add to bag
        .guarantee-text-wrap.text-center
          p.text-color-3.xs-f-xxsmall.md-f-small.max-at-tweak Try it risk-free with our 100% money-back guarantee

        .cta-container.cta-container--fixed.xs-f-xsmall.max-at-tweak(v-if="isMounted && !isDesktop" :class="{ 'cta-container--visible': bannerFixed }" ref="ctaFixed")
          MountedFlag(flag="with-sticky-cta")
          .cta-block.xs-12
            .xs-6.pr-50m
              MrBtn.shipment(
                xsmall
                noBorderRadius
                brandColor1
                block
                v-if="canAddToRefillCart"
                ref="ctaFixedButton"
                @click="trackAddToBagEvent(addProductToOrderOrBag, `${trackingPrefix} - Sticky Add to Shipment CTA`)"
                :disabled="Boolean(addingProduct)"
              ) Add to next shipment
              MrBtn(
                v-else
                xsmall
                noBorderRadius
                secondary
                block
                @click="handleBestMatchCtaClick"
                :disabled="Boolean(addingProduct)"
              ) {{ bestMatchCtaLabel }}

            .xs-6.pl-50m
              MrBtn(
                block
                xsmall
                noBorderRadius
                brandColor1
                :class="{ 'pdp-btn-secondary': canAddToRefillCart }"
                ref="ctaFixedButton"
                @click="trackAddToBagEvent(addToBag, `${trackingPrefix} - Sticky CTA`)"
                :disabled="Boolean(addingProduct)"
              ) Add to bag

</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import PdpCTAs from '@components/PDP/PdpCTAs/PdpCTAs';
  import OnPagePurchaseBox from '@components/PDP/OnPagePurchaseBox';
  import MrBtn from '@components/MrBtn';

  export default {
    name: 'PdpCTAsV2',
    mixins: [PdpCTAs],

    components: {
      OnPagePurchaseBox,
      MrBtn,
    },

    data() {
      return {
        isMounted: false,
      };
    },

    computed: {
      ...mapState('global', ['windowData']),
      ...mapState('customer', ['cdata']),
      ...mapState('cart', ['addingProduct']),

      bestMatch() {
        return this.cdata.bestColorMatch;
      },

      bestMatchCtaLabel() {
        if (this.bestMatch) {
          return 'Try It On';
        } else {
          return 'Find My Shade';
        }
      },

      bannerFixed() {
        return !this.isDesktop && this.isMounted;
      },

      isDesktop() {
        return this.windowData.breakpoint === 'desktop';
      },

      onPagePurchaseBoxExperiment() {
        return ((this.experiments["PDP On Page Purchase Box"] == "B") || (this.experiments["PDP On Page Purchase Box"] == "C")) && !(this.cmsSettings.showPerfectPairRoutine && this.addPerfectPair);
      },

      onPagePurchaseBoxExperimentVersion() {
        return this.experiments["PDP On Page Purchase Box"] || "A";
      },

      trackingPrefix() {
        return this.onPagePurchaseBoxExperiment ? `On Page Purchase Box ${this.onPagePurchaseBoxExperimentVersion}` : 'Color Kit Hero V2';
      }
    },

    mounted() {
      this.$nextTick(() => {
        this.isMounted = true;
      });
      if (this.experiments['PDP On Page Purchase Box']) {
        this.mix_trackExperimentViewed('PDP On Page Purchase Box');
      }
      if (this.onPagePurchaseBoxExperiment) {
        this.setSkipPurchasePanel(true);
      }
    },

    beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    },

    methods: {
      ...mapMutations('pdp', ['setSkipPurchasePanel']),
      ...mapActions('pdp', ['openPlaygroundModalWTrackEvent']),

      trackAddToBagEvent(originalFn, eventPrefix) {
        this.trackMREvent(`${eventPrefix} - Add to Bag`);
        originalFn();
      },

      handleBestMatchCtaClick() {
        if (this.bestMatch) {
          this.openPlaygroundModalWTrackEvent({
            event: 'Color Kit Hero V2 - Try It On',
            props: {
              eventPrefix: 'Color Kit Hero V2',
            }
          });
        } else {
          this.trackMREvent('Color Kit Hero V2 - Find My Shade');
          location.href = '/color-advisor';
        }
      }
    }
  };
</script>

<style lang="stylus" scoped>
.pdp-ctas-v2
  .cta-block
    width 100%
    display flex

  @media mq-mobile
    .mrbtn.shipment
      width 100%
      text-wrap wrap
    
  .guarantee-text-wrap
    padding 1em 0
    padding-bottom 2em

  .cta-container
    width 100%
    display flex
    justify-content center
    background-color #fff
    box-shadow 0 2px 5px rgba(0, 0, 0, 0.1)

  .pdp-btn
    background-color brand-color-1
    border 2px solid brand-color-1
    border-radius 0

  .pdp-btn-secondary
    background-color transparent
    color brand-color-1
    border 2px solid brand-color-1
    border-radius 0

    &:active,
      &:focus,
      &:hover
        background-color brand-color-1
        color #fff

  .cta-container--fixed
    position fixed
    bottom 0
    left 0
    z-index 1000
    opacity 0
    max-height 0
    overflow hidden
    padding 1em
    box-shadow 0px 4px 14px 0px rgba(0, 0, 0, 0.09)
    transition(all 200ms ease-in-out)

    &.cta-container--visible
      opacity 1
      max-height 6em
    .cta-block
      display flex

    :deep(.mrbtn)
      padding 0 1em
      width 100%
      height 4em
      text-wrap wrap
</style>